export type CsvColumn<Row> = {
  label: string
  value: (row: Row) => string | number | boolean | null | undefined
}

export function downloadCsv<Row>(
  filename: string,
  columns: CsvColumn<Row>[],
  rows: Row[],
) {
  const header = columns.map((column) => escapeCsvValue(column.label)).join(',')
  const body = rows
    .map((row) =>
      columns
        .map((column) => escapeCsvValue(column.value(row)))
        .join(','),
    )
    .join('\r\n')
  const blob = new Blob([`\uFEFF${header}\r\n${body}`], {
    type: 'text/csv;charset=utf-8',
  })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  document.body.appendChild(link)
  link.click()
  link.remove()
  URL.revokeObjectURL(url)
}

function escapeCsvValue(value: string | number | boolean | null | undefined) {
  const text = value === null || value === undefined ? '' : String(value)
  return `"${text.replace(/"/g, '""')}"`
}
